import styled from 'styled-components';
import * as variables from "pubweb-smokey/dist/components/GridSystem/_vars_widths";
import Colors from "pubweb-smokey/dist/colors";

export const WhyClaytonStyles = styled.div`
    @media screen and (min-width: ${variables.mobile_width_percentage}px) {
        .why-clayton {
            font-family: "acumin-pro",Helvetica,Arial,sans-serif;
            margin: 0 auto;
            text-align: center;

            h1 {
                color: #a1ce66;
                font-size: 34px;
                line-height: 50px;
                text-align: center;
            }
            h4 {
                color: #96d3ce;
                font-size: 18px;
            }
            p {
                color: #324460;
                font-size: 13px;
                line-height: 20px;
                margin: 0 13%;
            }
            .why-clayton-blurbs {
                margin-top: 40px;
            }
            .why-clayton-blurb {
                margin-bottom: 4.0em;
                opacity: 0;
            }
            .blurb-0, .blurb-2 {
                animation: flipInX 300ms;
                opacity: 1;
            }
            .blurb-1, .blurb-3 {
                //if blurb id is odd, have the effect happen a little slower
                animation: flipInX 1000ms;
                opacity: 1;
            }
            .piggy,
            .lightbulb,
            .floorplan,
            .speech-bubble {
                fill: #fff;
                margin-top: 6px;
                stroke: #fff;
                width: 65px;
            }
            .floorplan {
                fill: none;
                stroke-width: 3;
            }
            .speech-bubble {
                fill: #96d3ce;
                stroke-width: 3;
            }
            .why-clayton-circle {
                background-color: #96d3ce;
                border-radius: 50%;
                height: 77px;
                margin: 0 auto;
                padding: 10px;
                width: 77px;
            }
            .disclaimer {
                font-size: 9px;
                font-style: italic;
                line-height: 12px;
                margin: 40px 10%;
            }
        }
    }

    @media screen and (min-width: 768px) {
        .why-clayton {
            margin-top: -10em;
            width: 90%;
            h1 {
                font-size: 43px;
            }
            p, .why-Intro {
                margin: 0 2.5%;
            }
            p {
                font-size: 18px;
                line-height: 27px;
                margin: 0 -2%;
            }
            .why-clayton-blurbs {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
            }
            .why-clayton-blurb {
                width: 45%;
            }
            .disclaimer {
                font-size: 11px;
                margin: 90px 5%;
            }
        }
    }
`;